/* eslint-disable no-unused-vars */

/**
 * Function set value with storageKey form localStorage
 * @param storageKey
 * @param value
 * @returns
 */
export const setStorage = (storageKey: string, value?: string | null) => {
  localStorage.setItem(storageKey, value ?? '');
};

/**
 * Function get value form localStorage
 * @param storageKey
 * @returns
 */
export const getStorage = (storageKey: string) => {
  const value = localStorage.getItem(storageKey);
  if (!value) return null;
  return value;
};

export enum STORAGE_KEY {
  TOKEN = 'amatrium_token',
  USER = 'user',
  CHAKRA_UI_COLOR_MODE = 'chakra-ui-color-mode',
  SORT_FIELD_INDEX = 'sortFieldIndex',
  SORT_FIELD = 'sortField',
  IS_ASCENDING = 'isAscending',
  READ_BLOB_TOKEN = 'readBlobToken',
  ID = 'id',
  ID_TOKEN = 'id_token',
  I18_NEXT_LANGUAGE = 'i18nextLng',
}

export enum LANGUAGE {
  _EN = 'en',
  _JA = 'ja',
}
